import {tableData} from "@/common/api";
import {ElMessage} from "element-plus";
export default {
    methods: {
        getBanner() {
            window.scrollBy(0, 0);
            if(this.itemList) {
                this.itemList = [];
            }
            if(new URL(location.href).searchParams.get('parentId')) {
                let id = new URL(location.href).searchParams.get('parentId');
                tableData(id, {
                    cancel: false
                }).then(res=> {
                    if(res.success) {
                        let newArray = res.data.sort((a,b)=> a.sort > b.sort ? 1 : -1)
                        let topArray = [],
                            bottomArray = [],
                            fixedArray = [];
                        let haveContent = newArray.some(e=>e.contentType === 7)
                        if(!haveContent) {
                            topArray = newArray
                        }else {
                            let dix = newArray.findIndex(e=> e.contentType === 7),
                                last_dix = newArray.findLastIndex(e=> e.contentType === 7);
                            topArray = JSON.parse(JSON.stringify(newArray)).splice(0 , dix)
                            fixedArray = JSON.parse(JSON.stringify(newArray)).slice(dix , last_dix + 1)
                            bottomArray = JSON.parse(JSON.stringify(newArray)).splice(last_dix + 1, newArray.length)

                        }
                        this.topContent = topArray
                        this.fixedList = fixedArray
                        this.bottomContent = bottomArray
                        if(this.activeContent) {
                            this.activeContent = this.fixedList[0]
                        }
                        // res.data.forEach(e=> {
                        //     if(e.contentType === 4) {
                        //         this.banners.push(e)
                        //     }else {
                        //
                        //     }
                        //     if (e.note === "banner") {
                        //         this.bannerSrc = e.imagePath;
                        //     }
                        //     if ((type === "core" || type === "aboutus") && e.note === "top-text") {
                        //         this.topContent = e.content
                        //     }
                        //     if (type === "aboutus" && e.note === "bottom-text") {
                        //         this.bottomContent = e.content
                        //     }
                        //     if (type === "core" && e.note === "content" && this.itemList) {
                        //         fixeArray.push(e)
                        //     }
                        //     if (type === "aboutus" && e.note === "fixed" && this.timeList) {
                        //         fixeArray.push(e)
                        //     }
                        // })
                        // setTimeout(()=>{
                        //     if (type === "aboutus") {
                        //         this.timeList = fixeArray
                        //         if(this.timeList.length > 0) {
                        //             this.activeContent = this.timeList[0]
                        //         }
                        //     }else if(type === "core") {
                        //         this.itemList = fixeArray
                        //     }
                        // },100)
                    }else {
                        ElMessage.error('获取页面banner失败，请刷新页面重试！')
                    }
                }).catch(()=>{
                    ElMessage.error('获取页面banner失败，请刷新页面重试！')
                })
            }
        }
    },
}
